/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterDailyMonitoringDetails } from '../types/FilterDailyMonitoringDetails'

interface DailyMonitoringDetailsFiltersContextType {
  filters: FilterDailyMonitoringDetails
  setFilters: (filters: FilterDailyMonitoringDetails) => any
}
const initialState: DailyMonitoringDetailsFiltersContextType = {
  filters: {
    date: {
      year: +moment().year(),
      month: +moment().month() + 1,
      time_zone: '-03:00'
    },
    states: [],
    cities: []
  },
  setFilters: () => {}
}
const storageItem = 'filters-daily-monitoring-details-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const DailyMonitoringDetailsFiltersContext = createContext(initialState)

const DailyMonitoringDetailsFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <DailyMonitoringDetailsFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </DailyMonitoringDetailsFiltersContext.Provider>)
}

export default DailyMonitoringDetailsFiltersContextProvider
